import { NgModule, Type } from '@angular/core';
import { CplaceSingleReferenceControlComponent, CplaceSingleReferenceControlModule } from '../components';
import { CfControlPlugin } from './cf-control-plugin';

export class CplaceSingleReferenceControlPlugin extends CfControlPlugin<CplaceSingleReferenceControlComponent> {
  public readonly component = CplaceSingleReferenceControlComponent;
  public readonly module = CplaceSingleReferenceControlModule as Type<NgModule>;
}
